import { render, staticRenderFns } from "./EcgVisitaEdit.vue?vue&type=template&id=d16fcb44"
import script from "./EcgVisitaEdit.vue?vue&type=script&lang=js"
export * from "./EcgVisitaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports